import { useHistory, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes';
import { parse } from 'query-string';

export const useErrorParam = (shouldThrow = true): Error | undefined => {
  const { pathname, search } = useLocation();
  const { error }: { error?: string } = parse(search);
  const history = useHistory();
  if (error) {
    if (shouldThrow) {
      history.push(ROUTES.login);
      throw new Error(error);
    }
    history.replace(pathname);
    return new Error(error);
  }
};
